import { Dialog } from "@headlessui/react";
import { useEffect, useState } from "react";
import { getOrgCouponPolicy} from "../../services/ api_services";

const OrgCouponHistoryDialog = ({ isOpen, onClose, gridRow, orgTree }) => {
    const [list, setList] = useState([]);

    useEffect(() => {
        
        let source_org_id = gridRow.admin_info.org_id;

        console.log("GRID ROW ==> ", gridRow, " Org_id:", source_org_id);
        console.log("orgTree ==> ", orgTree);

        fetchOrgCouponPolicy(source_org_id);

    }, [gridRow]);

    const fetchOrgCouponPolicy = async (source_org_id) => {
        try {
            const response = await getOrgCouponPolicy(source_org_id);
            console.log(response);
            setList(response.data);
            
        } catch (e) {

        }
    }

    const getOrgName = (orgId, orgTree) => {
        if (!orgId || !Array.isArray(orgTree)) return 'N/A';
        const org = orgTree.find((item) => String(item.id) === String(orgId));
        return org ? org.name2 : 'N/A';
    };
    
    function formatDateTime(dateTimeStr) {
        if (!dateTimeStr) return null;
        return dateTimeStr.replace(/(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})\.\d+/, '$1');
    }

    return (
        <Dialog
            as="div"
            className="relative z-50"
            open={isOpen} // showPopup에 전달
            onClose={onClose}
            aria-label="쿠폰 이력 다이얼로그"
        >
        <div className="fixed inset-0 bg-black bg-opacity-40 z-40">
            <div className="fixed inset-0 flex justify-center items-center z-50">
                <Dialog.Panel className="bg-white rounded-md p-6 max-w-4xl w-full max-h-[80vh] overflow-y-auto shadow-lg">
                    <table className="min-w-full divide-y divide-gray-300">
                    <thead className="sticky top-0 bg-white">
                        <tr>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">번호</th>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">발신 조직</th>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">수신조직</th>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">총 발행 회원권 수</th>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">발행인</th>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">날짜</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {list.length > 0 ? (
                        list.map((item, idx) => (
                            <tr key={item.id || `row-${idx}`}>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{idx+1}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{getOrgName(item.source_org_id, orgTree)}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{getOrgName(item.target_org_id, orgTree)}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{item.max_coupon_count.toLocaleString() || 0}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{item.up_admin_nm || item.reg_admin_nm}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{formatDateTime(item.target_dt) || formatDateTime(item.source_dt)}</td>
                            </tr>
                        ))
                        ) : (
                        <tr>
                            <td colSpan="6" className="text-center py-4 text-sm text-gray-500">
                            발행한 이력이 없습니다.
                            </td>
                        </tr>
                        )}
                    </tbody>
                    </table>
                </Dialog.Panel>
            </div>
        </div>
    </Dialog>
    );
}

export default OrgCouponHistoryDialog;